import React from 'react';

import Alert from '../ui/Alert';

interface JobStatusAlertProps {
  status?: string;
  runningSuffix?: string;
  headingStyle?: React.CSSProperties;
  hasPollFailed?: boolean;
}

function JobStatusAlert({
  status,
  runningSuffix = '',
  headingStyle,
  hasPollFailed = false,
}: JobStatusAlertProps): JSX.Element {
  return (
    <>
      <Alert bsStyle={status?.startsWith('error') ? 'danger' : 'info'}>
        <h4 style={headingStyle}>
          {/* Preserve the server's message after the status prefix. */}
          {status
            ? status.charAt(0).toUpperCase() + status.slice(1)
            : 'Checking status...'}
          {status === 'running' && runningSuffix}
        </h4>
      </Alert>
      {hasPollFailed && (
        <Alert bsStyle="warning">Unable to check status. Retrying...</Alert>
      )}
    </>
  );
}

export default JobStatusAlert;
